import React from 'react';
import { Card, CardActionArea, CardMedia, Typography, Grid, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';

const styles = theme => ({
    loadMoreImageCard: {
        margin: theme.spacing(0.5),
        background: theme.palette.background.paperDark
    },
    loadMoreGrid: {
        height: '100%'
    }
});

const MediaPickerLoadMoreCard = (props) => {
    const { classes, onLoadMoreButtonClick, isLoading, galleryCardWidth, galleryCardHeight } = props

    return (
        <Grid>
            <Card
                className={classes.loadMoreImageCard}
                style={{ width: galleryCardWidth }}
                onClick={() => !isLoading && onLoadMoreButtonClick()}
            >
                <CardActionArea>
                    <CardMedia
                        style={{ height: galleryCardHeight }}
                        children={
                            <Grid
                                container
                                className={classes.loadMoreGrid}
                                direction='column'
                                justifyContent='center'
                                alignItems='center'
                            >
                                {isLoading
                                    ?
                                    <CircularProgress />
                                    :
                                    <>
                                        <Grid>
                                            <Typography
                                                variant='subtitle2'
                                                color='textSecondary'
                                            >
                                                Load More
                                            </Typography>
                                        </Grid>
                                        <Grid>
                                            <AddCircleRoundedIcon fontSize='large' />
                                        </Grid>
                                    </>
                                }
                            </Grid>
                        }
                    />
                </CardActionArea>
            </Card>
        </Grid>
    );
}

export default withStyles(MediaPickerLoadMoreCard, styles);